// Agent keep in sync: the StructuredTable.Kind enum in
// benchling/notebook/structured_tables/models/structured_table.py
// and browser-tests/lib/notebook/regions/entries/StructuredTableView.ts.
//
// This module intentionally has no dependencies so it can be imported from
// non-browser tooling (e.g. NES codegen scripts).
//
// When adding a new kind, run: cd services/notebook-evaluation && yarn sync:evaluate-contract
export enum StructuredTableKind {
  MIXTURE_METADATA = 'MIXTURE_METADATA',
  MIXTURE_INGREDIENTS = 'MIXTURE_INGREDIENTS',
  INVENTORY = 'INVENTORY',
  PLATE_CREATION = 'PLATE_CREATION',
  BOX_CREATION = 'BOX_CREATION',
  RUN_OUTPUT_SAMPLES = 'RUN_OUTPUT_SAMPLES',
  REGISTRATION = 'REGISTRATION',
  RESULTS = 'RESULTS',
  TRANSFER = 'TRANSFER',
  PROCESS_OUTPUT = 'PROCESS_OUTPUT',
  PROCESS_TASK = 'PROCESS_TASK',
  LOOKUP = 'LOOKUP',
  PARAMETER = 'PARAMETER',
  STOICHIOMETRY = 'STOICHIOMETRY',

  // Fill-plate transfer tables are never used in the notebook, so they aren't persisted.
  FILL_PLATE_TRANSFER_SUMMARY_VIEW = 'FILL_PLATE_TRANSFER_SUMMARY_VIEW',
  FILL_PLATE_TRANSFER_WELL_VIEW = 'FILL_PLATE_TRANSFER_WELL_VIEW',
  FILL_PLATE_TRANSFER_PLATE_RECORD = 'FILL_PLATE_TRANSFER_PLATE_RECORD',

  // Bulk assembly tables are never used in a notebook context, so do not need to be specified on the backend.
  BULK_ASSEMBLY_FRAGMENTS = 'BULK_ASSEMBLY_FRAGMENTS',
  BULK_ASSEMBLY_CONSTRUCTS = 'BULK_ASSEMBLY_CONSTRUCTS',
  BULK_ASSEMBLY_PRIMERS = 'BULK_ASSEMBLY_PRIMERS',

  // These Procedures table types are for configuration only. They are not persisted or rendered
  // in notebook entries or documents.
  PROCEDURE_MATERIAL_INPUTS = 'PROCEDURE_MATERIAL_INPUTS',
  PROCEDURE_MATERIAL_OUTPUTS = 'PROCEDURE_MATERIAL_OUTPUTS',
  PROCEDURE_DATA_PARAMETERS_CONFIG = 'PROCEDURE_DATA_PARAMETERS_CONFIG',
  PROCEDURE_DATA_PARAMETERS_CONFIG_WITH_PARAM_LIBRARY = 'PROCEDURE_DATA_PARAMETERS_CONFIG_WITH_PARAM_LIBRARY',
  PROCEDURE_EQUIPMENT = 'PROCEDURE_EQUIPMENT',

  // Protein creation tables are transient and never persisted or embedded in notebooks.
  PROTEIN_CREATION = 'PROTEIN_CREATION',

  TEST_DEFINITIONS = 'TEST_DEFINITIONS',

  APP_CANVAS = 'APP_CANVAS',
}
